import { Avatar, AvatarProps } from "@mui/material";
import React, { FC } from "react";
import { CompanyHeaderFragment } from "./fragments.types";

export interface CompanyAvatarProps extends AvatarProps {
  company: Pick<CompanyHeaderFragment, "name" | "avatar">;
}

/**
 * Avatar for company. Falls back to the first letter of the company name when the
 * company has no picture - unlike workers, companies have no dummy image.
 */
export const CompanyAvatar: FC<CompanyAvatarProps> = ({ company, ...props }) => (
  <Avatar alt={company.name} src={company.avatar?.url} variant="square" {...props}>
    {company.name[0]}
  </Avatar>
);
